import React from 'react';
import classNames from 'classnames';

type Level = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';

export interface CardHeaderProps {
  children: React.ReactNode;
  as?: Level;
  headerClassName?: string;
  headingClassName?: string;
  id?: string;
}

/**
 * The Card Header based on [The USWDS card component](https://designsystem.digital.gov/components/card/)
 *
 */
const CardHeader = ({
  children,
  headerClassName,
  headingClassName,
  id,
  as: Component = 'h2',
}: CardHeaderProps): JSX.Element => {
  return (
    <header id={id} className={classNames('usa-card__header', headerClassName)}>
      <Component className={classNames('usa-card__heading', headingClassName)}>{children}</Component>
    </header>
  );
};

export default CardHeader;
